export default __webpack_public_path__ + "static/media/3.c3ba3e39.jpg";